var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"36":1,"157":1,"198":1,"358":1,"474":1,"500":1,"690":1,"832":1,"954":1,"968":1,"1003":1,"1170":1,"1536":1,"1635":1,"1660":1,"1715":1,"1729":1,"1739":1,"1884":1,"1931":1,"2088":1,"2100":1,"2372":1,"2395":1,"2411":1,"2416":1,"2426":1,"2632":1,"2687":1,"2727":1,"2754":1,"2795":1,"2811":1,"2822":1,"3006":1,"3087":1,"3123":1,"3431":1,"3460":1,"3523":1,"3852":1,"3914":1,"3943":1,"4032":1,"4203":1,"4266":1,"4360":1,"4645":1,"4905":1,"4914":1,"5006":1,"5098":1,"5163":1,"5177":1,"5256":1,"5314":1,"5406":1,"5496":1,"5657":1,"5669":1,"5671":1,"5692":1,"6100":1,"6128":1,"6557":1,"6856":1,"6936":1,"7149":1,"7366":1,"7398":1,"7436":1,"7475":1,"7513":1,"7571":1,"7576":1,"7688":1,"7941":1,"7962":1,"8268":1,"8373":1,"8380":1,"8530":1,"8650":1,"9002":1,"9101":1,"9152":1,"9155":1,"9244":1,"9308":1,"9378":1,"9427":1,"9448":1,"9458":1,"9514":1,"9630":1,"9908":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr